<template>
  <q-card style="min-width: 350px">
    <q-card-section>
      <div class="text-h6">Randevu Guncelle</div>
    </q-card-section>
    <q-card-actions align="right" class="text-primary">
      <q-btn
        v-close-popup
        label="Diyet Seansi"
        color="secondary"
        @click="onDiet"
      />
      <q-btn
        v-close-popup
        label="Bolgesel Zayiflama"
        color="secondary"
        @click="onRegional"
      />
    </q-card-actions>
  </q-card>
</template>

<script>
import { useQuasar } from 'quasar'
import { toRefs, inject } from 'vue'
import axios from 'axios'
import * as eventNames from '../../utils/events'
import * as notify from '../../utils/notification'

export default {
  props: {
    appointmentId: String,
  },
  setup(props) {
    const $q = useQuasar()
    const emitter = inject('emitter')
    let { appointmentId } = toRefs(props)

    // note form inputs

    return {
      onDiet() {
        console.log(appointmentId)
        axios
          .post(
            `appointments/${appointmentId.value}/changeType?type=REGIME_SESSION`
          )
          .then(() => {
            $q.notify(notify.success('Randevu guncellendi.'))
            emitter.emit(eventNames.REFRESH_CUSTOMER_APPOINTMENTS)
          })
          .catch(() => {
            $q.notify(notify.warning('Randevu guncellenemedi.'))
          })
      },
      onRegional() {
        axios
          .post(
            `appointments/${appointmentId.value}/changeType?type=REGIONAL_LOSS`
          )
          .then(() => {
            $q.notify(notify.success('Randevu guncellendi.'))
            emitter.emit(eventNames.REFRESH_CUSTOMER_APPOINTMENTS)
          })
          .catch(() => {
            $q.notify(notify.warning('Randevu guncellenemedi.'))
          })
      },
    }
  },
}
</script>
